var exports = {
  "q": "GifIndicator.module__indicator___SlBJdj",
};

module.exports = exports;
